import { Accordion, AccordionItem } from '@heroui/react'
import DOMPurify from 'dompurify'
import { useTranslate } from '@/hooks'
import { NavArrowRightIcon } from '@/ui/icons/nav-arrow-right'

interface ProductExtraDetailsProps {
  details: string
}

export const ProductExtraDetails = ({ details }: ProductExtraDetailsProps) => {
  const { translate } = useTranslate()

  return (
    <Accordion showDivider={false} hideIndicator className="p-0">
      <AccordionItem
        key="anchor"
        aria-label={translate('full_catalog_extra_details')}
        title={translate('full_catalog_extra_details')}
        startContent={<NavArrowRightIcon width={20} height={20} />}
        classNames={{
          title: 'text-xs md:text-sm',
          trigger: 'group py-0 font-medium gap-2 text-xs md:text-sm -ml-1',
          startContent: 'group-data-[open=true]:rotate-90 transition-transform'
        }}
      >
        <p
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(details)
          }}
          className="line-clamp-3 text-xs font-normal !leading-normal text-neutral-600 md:text-sm"
        />
      </AccordionItem>
    </Accordion>
  )
}
